module.exports = __webpack_public_path__ + "static/propriety-platform-86a61bdd9e80a98bca231a6c7d02f6e5.png";